import { useIsAdmin } from 'root/src/client/v2/auth/hooks/useIsAdmin';
import { useUserData } from 'root/src/client/v2/userData/hooks/useUserData';
import { getCanEarnPoints } from 'root/src/shared/util/getCanEarnPoints';
// Mirrors the legacy HeroSection gate (`(canEarnPoints || isAdmin) && pointsLimit`): the points UI
// (meter, "How to earn points", the drops-list chip) is only for creators who can actually earn
// points (Twitch Partners with CCV >= pointsMinCcv, or allowlisted), with an admin bypass so
// internal accounts keep visibility. Deliberately NOT tied to the drop's viewership breakpoints
// (maxDares): points eligibility is a creator-level bar, not a per-drop dare allowance.
export const usePointsEligibility = (drop) => {
    var _a, _b, _c, _d;
    const { userData } = useUserData();
    const { isAdmin } = useIsAdmin();
    const canEarnPoints = getCanEarnPoints({
        ccv: (_b = (_a = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _a === void 0 ? void 0 : _a.ccv) !== null && _b !== void 0 ? _b : 0,
        isPartner: ((_c = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _c === void 0 ? void 0 : _c.broadcasterType) === 'partner',
        dropEvent: { id: drop.id, awardPoints: drop.awardPoints },
        isAbleToParticipate: (_d = drop.isAbleToParticipate) !== null && _d !== void 0 ? _d : true,
        isCreatorPointsAllowlisted: Boolean(drop.isCreatorPointsAllowlisted),
    });
    return { canEarnPoints, isAdmin, showPointsUi: canEarnPoints || isAdmin };
};
